/**
 * 尝试解析 JSON 字符串
 * @param str 要解析的 JSON 字符串
 * @param defaultValue 如果解析失败，返回的默认值
 * @returns 解析后的对象或默认值
 */
export const tryJson = <T = any>(str: string, defaultValue?: T ): T | null => {
  try {
    return JSON.parse(str)
  } catch (error) {
    return defaultValue ?? null
  }
}


export default tryJson
